// extracted by mini-css-extract-plugin
export default {"title":"_4a7edc8d1c","inner_title":"c004a65811","charge_btn":"b469f201db"};